import { useGoogleMap } from "@react-google-maps/api"
import React, { useEffect } from "react"
import { createPortal } from "react-dom"

enum MapControlPosition {
  "TOP_LEFT" = 1,
  "TOP_CENTER" = 2,
  "TOP" = 2,
  "TOP_RIGHT" = 3,
  "LEFT_CENTER" = 4,
  "LEFT_TOP" = 5,
  "LEFT" = 5,
  "LEFT_BOTTOM" = 6,
  "RIGHT_TOP" = 7,
  "RIGHT" = 7,
  "RIGHT_CENTER" = 8,
  "RIGHT_BOTTOM" = 9,
  "BOTTOM_LEFT" = 10,
  "BOTTOM_CENTER" = 11,
  "BOTTOM" = 11,
  "BOTTOM_RIGHT" = 12,
  "CENTER" = 13,
}

type MapControlPositionStrings = keyof typeof MapControlPosition
export interface MapControlProps {
  // Added strongly typed position strings to avoid bugs and improve developer experience
  position: MapControlPositionStrings
  children?: React.ReactNode
}
const MapControl = ({
  children,
  position = "BOTTOM_CENTER",
}: MapControlProps) => {
  const map = useGoogleMap()
  const controlDiv = document.createElement("div")
  useEffect(() => {
    const controls = map?.controls?.[MapControlPosition[position]]
    const index = controls?.getLength?.()
    controls?.push(controlDiv)
    return () => {
      if (typeof controls !== "undefined") {
        try {
          controls?.removeAt?.(index)
        } catch {
          console.log("Error: Cannot remove control")
        }
      }
    }
  }, [position, controlDiv, map?.controls])
  if (!controlDiv) return null
  return createPortal(
    <div style={{ marginLeft: 16, marginTop: 16 }}>{children}</div>,
    controlDiv
  )
}

export default MapControl
